import * as d3 from 'd3'

import events from './events'
import axis from './axis'
import zoomTool from './zoom'
import layout from './layout'

import moment from 'moment'

let timeScale = null
let zoomedTimescale = null
let width = 800
let graph
let view
let svg
let onTimescaleChange
let zoom

export default (config) => {
    function init(selection) {
      selection.selectAll('svg').remove()

      let data = selection.data()
      let events = layout.generate(data[0])

      let {
        margin,
        onEventClick,
        dateFrom = moment.utc().subtract(8, 'months'),
        dateTo = moment.utc(),
        onMouseOver,
        enableZoom = true
      } = config

      onTimescaleChange = config.onTimescaleChange

      width = selection.node().clientWidth - margin.right - margin.left
      let height = layout.getHeight(events)

      svg = selection
        .append('svg')
        .datum(data)
        .attr('width', width + margin.right + margin.left)
        .attr('height', height + axis.HEIGHT + margin.top + margin.bottom)

      setTimeScale({
        dateFrom,
        dateTo
      })

      graph = svg
        .append('g')
        .classed('graph', true)
        .attr('transform', `translate(${margin.left},${margin.top})`)

      view = graph.append('g')
        .classed('view', true)

      zoom = zoomTool({
        timeScale,
        view,
        draw,
        enableZoom,
        onTimescaleChange: _onTimescaleChange
      })
      svg.call(zoom)

      view.call(draw(timeScale, onEventClick, height))

      svg.on('mousemove', (event) => {
        onMouseOver(moment.utc(zoomedTimescale.invert(event.x - 210)).format('YYYY-MM-DDTHH:mm:ss.000'))
      })
    }

    function _onTimescaleChange (timescale) {
      zoomedTimescale = timescale
      onTimescaleChange(timescale.domain())
    }

    function setTimeScale (config) {
      let {
        dateFrom,
        dateTo
      } = config

      timeScale = zoomedTimescale = d3.scaleUtc()
          .domain([
            dateFrom,
            dateTo
          ])
          .range([0, width])
    }

    function moveTo (domain) {
      let x = timeScale(domain[0]) * -1
      let y = 0
      let zoomIdentity = d3.zoomIdentity.translate(x,y).scale(1)
      svg.transition().duration(750).call(zoom.transform, zoomIdentity)
    }

    function reset () {
      svg.transition().duration(750).call(zoom.transform, d3.zoomIdentity)
    }

    function chart(selection) {
        chart.moveTo = moveTo
        chart.reset = reset
        chart._init = () => init(selection)
        chart._init()

        if (config.widthResizable) {
            global.addEventListener('resize', chart._init, true)
        }
    }

    function draw(timeScale, onEventClick, height) {
        return selection => {
            selection
                .data(selection.data())
                .call(events.draw({
                    timeScale,
                    onEventClick,
                }))
                .call(axis.draw({
                    timeScale,
                    height
                }))
        }
    }

    return chart

}